import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import QuantityControlCart from '../helper/QuantityControlCart';
import {  addToCart, addToCompare, removeFromWishList, updateWishListQuantity } from '../common/slices/productSlice';
import { getUserData } from '../auth';
 
const WishListSectionAmazon = () => {
    
    const cartItems = useSelector((state) => state.product.wishList); // Access cart items from Redux store
    const dispatch = useDispatch();
 
  const userData = getUserData();
  const userId = userData?.uid || "";
  console.log('userId',userId)
  
    const handleTest = async () => { 
      
      console.log('cartItems',cartItems);

  
    };
 
    
    const handleRemoveItem = (id) => {
      // Dispatch an action to remove the item
       dispatch(removeFromWishList(id));

  };
    const handleUpdateQuantity = (id, quantity) => {
        // Dispatch an action to update quantity
         dispatch(updateWishListQuantity({ id, quantity }));

    };

    const handleSubmitCart = (product) => {
 
         dispatch(addToCart(product));  // Dispatch action to add product to cart
         alert("The product has been added to the cart! Please note: The data is temporarily saved in the cart and will not be finalized until checkout.");
         dispatch(removeFromWishList(product?.id));

       };

    const handleSubmitCompare = (product) => {

           dispatch(addToCompare(product));  // Dispatch action to add product to cart
           alert("The product has been added to the compare! Please note: The data is temporarily saved in the compare list and will not be finalized until checkout.");
           dispatch(removeFromWishList(product?.id));

         };
 
    return (
        <section className="cart py-80">
            <div className="container container-lg">
                <div className="row gy-4">
                <div className='col-lg-11'>
                <div className="cart-table border border-gray-100 rounded-8 px-40 py-48">
                            <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                                <table className="table style-three">
                                    <thead>
                                        <tr>
                                            <th className="h6 mb-0 text-lg fw-bold">Delete</th>
                                            <th className="h6 mb-0 text-lg fw-bold">Product Name</th>
                                            <th className="h6 mb-0 text-lg fw-bold">Price</th>
                                            <th className="h6 mb-0 text-lg fw-bold">Quantity</th>
                                            <th className="h6 mb-0 text-lg fw-bold">Subtotal</th>
                                            <th className="h6 mb-0 text-lg fw-bold">Actions</th>

                                        </tr>
                                    </thead>
                                    <tbody>
  {cartItems.length > 0 ? (
    cartItems.map((item) => {
      const product = item;
      const productImage =
        product.images && product.images.length > 0
          ? product.images[0] // Get the first image
          : "assets/images/thumbs/product-placeholder.png"; // Placeholder image

      return (
        <tr key={item.id}>
          <td>
            <button
              type="button"
              onClick={() => handleRemoveItem(item.id)}
              className="remove-tr-btn flex-align gap-12 hover-text-danger-600"
            >
              <i className="ph ph-x-circle text-2xl d-flex" />
              Remove
            </button>
          </td>
          <td>
            <div className="table-product d-flex align-items-center gap-24">
              <Link
                to={`/#`}
                className="table-product__thumb border border-gray-100 rounded-8 flex-center"
              >
                <img
                  src={productImage}
                  alt={product.name || "Product Image"}
                  className="img-fluid"
                />
              </Link>
              <div className="table-product__content text-start">
                <h6 className="title text-lg fw-semibold mb-8">
                  <Link
                    to={`/#`}
                    className="link text-line-2"
                  >
                    {product.name}
                  </Link>
                </h6>
              </div>
            </div>
          </td>
          <td>
            <span className="text-lg h6 mb-0 fw-semibold">
              ${item.price.toFixed(2)}
            </span>
          </td>
          <td>
            <QuantityControlCart
              initialQuantity={item.quantity}
              onQuantityChange={(quantity) =>
                handleUpdateQuantity(item.id, quantity)
              }
            />
          </td>
          <td>
            <span className="text-lg h6 mb-0 fw-semibold">
              ${(item.price * item.quantity).toFixed(2)}
            </span>
          </td>
          <tr>
         <td className="px-40 py-32">
           <button
              className="btn btn-main-two rounded-8 px-64"
              onClick={() => handleSubmitCart(item)}

             >
             Add To Cart <i className="ph ph-shopping-cart" />
           </button>
         </td>
       </tr>
       <tr>
         <td className="px-40 py-32">
           <button
              className="btn btn-main-two rounded-8 px-64"
              onClick={() => handleSubmitCompare(item)}
             >
             Add To Compare <i className="ph-fill ph-shuffle" />
           </button>
         </td>
       </tr>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="5" className="text-center">
        Your WishList is empty.
      </td>
    </tr>
  )}
</tbody>

                                </table>
                            </div>
                           
                        </div>
                    </div> 
                </div>
            </div>
        </section>
    );
};

export default WishListSectionAmazon;